import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { allPostByKeyword } from '../../redux/filter/actions';

const SearchBar = () => {
    const dispatch = useDispatch();
    const [search, setSearch] = useState('');

    const handleChange = (e) => {
        setSearch((e.target.value));
    }

    const debounce = (func, delay) => {
        let timeoutId;
        return (...args) => {
            if (timeoutId) {
                clearTimeout(timeoutId);
            }
            timeoutId = setTimeout(() => {
                func(...args);
            }, delay);
        }
    }

    useEffect(() => {
        dispatch(allPostByKeyword(search))
    }, [search, dispatch]);


    return (
        <div
            className="border mt-6 border-slate-200 flex items-center w-11/12 lg:w-1/2 mx-auto bg-gray-50 h-12 px-5 rounded-lg text-sm ring-emerald-200"
        >
            <input
                className="outline-none border-none bg-gray-50 h-full w-full mr-2"
                type="search"
                name="search"
                onChange={debounce(handleChange, 800)}
                placeholder="Search"
            />
            <img
                className="inline h-6 cursor-pointer"
                src="https://raw.githubusercontent.com/Learn-with-Sumit/think-in-a-redux-way/8f0d972d3ba07b8c7952074dcf2fed283f49def8/html_template/assets/search.svg"
                alt="Search"
            />
        </div>

    );
};

export default SearchBar;